import { render, staticRenderFns } from "./ParametrosLocalesHolder.vue?vue&type=template&id=a7222842&scoped=true"
import script from "./ParametrosLocalesHolder.vue?vue&type=script&lang=js"
export * from "./ParametrosLocalesHolder.vue?vue&type=script&lang=js"
import style0 from "./ParametrosLocalesHolder.vue?vue&type=style&index=0&id=a7222842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7222842",
  null
  
)

export default component.exports